<mat-toolbar>Edit department</mat-toolbar>
<div class="Dialog-body">
  <form>
    
    <mat-form-field style="width: 400px;padding-top: 1.25em;">
      <input type="text" [(ngModel)]="selectedName" [ngModelOptions]="{standalone: true}" matInput placeholder="Name">
    </mat-form-field>

    <mat-form-field style="width: 400px;padding-top: 1.25em;">
      <input type="text"[(ngModel)]="selectedDescription" [ngModelOptions]="{standalone: true}" matInput placeholder="Description">
    </mat-form-field>

    <mat-form-field style="width: 400px;padding-top: 1.25em;">
      <mat-select placeholder="{{'State'}}"   [(ngModel)]="inputValuestate" name="Site" [formControl]="state" required>            
        <mat-option *ngFor="let Site of siteCodesList" [value]="Site.Id">
          {{Site.SiteName}} </mat-option>
        </mat-select> 
        <mat-error *ngIf="state.invalid">{{getErrorMessage()}}</mat-error>
    </mat-form-field>

    <mat-form-field style="width: 400px;padding-top: 1.25em;">
      <mat-select placeholder="{{'Safety Observations'}}"   [(ngModel)]="inputValueSefetyObservation" name="sefetyobservation" [formControl]="sefetyobservation" required>            
        <mat-option [value]="1">Work Area</mat-option>
        <mat-option [value]="2">Office</mat-option>
        </mat-select> 
        <mat-error *ngIf="sefetyobservation.invalid">{{getObservationErrorMessage()}}</mat-error>
    </mat-form-field>
    
      <div class="buttonbelow">
        <button mat-raised-button (click)="DialogClose()">Cancel</button>    
        <button mat-raised-button (click)="UpdateDepartment()">Submit</button>
       
      </div>
  </form>

</div>
